export default __webpack_public_path__ + "media/images/brands/dyson-ec4b2de6e83e29075fd7825f9883b3c0.png";